import { Component, OnInit } from '@angular/core';
import { OnboardingLpService } from './onboarding-lp.service';
import { LpUiService } from '../shared/lp-ui.service';

@Component({
  selector: 'terra-onboarding-lp',
  templateUrl: './onboarding-lp.component.html',
  styleUrls: ['./onboarding-lp.component.scss'],
  providers: [OnboardingLpService]
})
export class OnboardingLpComponent implements OnInit {

  constructor(private lpUiService: LpUiService) {
    this.lpUiService.hideMainNav();
  }

  ngOnInit() {
  }

}
